// General
import "./support-form-dialog.scss";
import { useEffect, forwardRef } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  resetSupportFormObj,
  updateSelectedPath,
} from "../../../../redux/store/supportStore";
import { updateSupportFormDialog } from "../../../../redux/store/dialogStore";
// Material UI
import { Dialog, Slide, useMediaQuery } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// i18next
import { useTranslation } from "react-i18next";

const SupportFormDialog = () => {
  // Redux variables
  const supportFormDialog = useSelector(
    (state) => state.dialog.supportFormDialog
  );
  const supportFormObj = useSelector((state) => state.support.supportFormObj);
  const selectedPath = useSelector((state) => state.support.selectedPath);
  const dispatch = useDispatch();

  // MUI variables
  const isMobile = useMediaQuery("(max-width: 720px)");

  // i18next variables
  const { t } = useTranslation();

  // Lifecycle | Mounted
  useEffect(() => {
    if (supportFormDialog) {
    } else {
      dispatch(resetSupportFormObj());
    }
  }, [supportFormDialog]);

  // Event Handlers | Dialog
  const onCloseDialog = () => {
    dispatch(updateSupportFormDialog(false));
  };

  // Event Handlers | Button
  const onSelectSupportOption = (option) => {
    const level = supportFormObj?.level || 0;
    const key = option?.key;
    const label = option?.label;
    const prev = selectedPath || [];
    const next = prev.slice(0, level);
    next[level] = { key, label };
    dispatch(updateSelectedPath(next));

    onCloseDialog();
  };

  return (
    <Dialog
      className="custom-dialog-margin-top"
      fullScreen={isMobile ? true : false}
      open={supportFormDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <div id="support-form-dialog">
        <div className="dialog-header">
          <div className="left-container" onClick={onCloseDialog}>
            <ChevronLeftIcon className="back-icon" />
          </div>
          <div className="middle-container">
            {supportFormObj?.placeholder ||
              t(
                supportFormObj?.level === 0
                  ? "support.select_category"
                  : "support.select_subcategory"
              )}
          </div>
          <div className="right-container"></div>
        </div>

        <div className="top-container">
          <div style={{ padding: "15px" }} />

          <div className="title">{supportFormObj?.title}</div>

          <div style={{ padding: "10px" }} />

          <div className="body-container">
            {supportFormObj?.options?.map((option, index) => (
              <div
                className={`support-item ${option?.key === selectedPath[supportFormObj?.level]?.key && "selected"}`}
                key={index}
                onClick={() => onSelectSupportOption(option)}
              >
                {option?.label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default SupportFormDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
